import { postApi } from '../apiFetch';
import type {
  EngagementRiskInput,
  EngagementRiskOutput,
  SessionToMissionsInput,
  SessionToMissionsOutput,
} from './aiTypes';

/**
 * פונקציה 1: חישוב סיכון נטישה
 * שולחת בקשה לשרת הפנימי (API), שמדבר עם Azure.
 */
export async function getEngagementRisk(
  payload: EngagementRiskInput,
): Promise<EngagementRiskOutput> {
  // שליחת בקשה לקובץ ה-API בשרת
  // שים לב: הנתיב תואם לשם הקובץ בתיקיית api (לפי התמונה ששלחת)
  const res = await postApi('/api/ai-engagement-risk', payload);

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    console.error('AI engagement risk failed:', text || res.statusText);
    throw new Error('AI engagement risk failed');
  }

  return res.json();
}

/**
 * פונקציה 2: יצירת טיוטת משימות מסשן
 * שולחת בקשה לשרת הפנימי (API), שמדבר עם Azure.
 */
export async function getSessionMissionsDraft(
  payload: SessionToMissionsInput,
): Promise<SessionToMissionsOutput> {
  // שליחת בקשה לקובץ ה-API בשרת
  const res = await postApi('/api/ai-session-to-missions', payload);

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    console.error('AI missions draft failed:', text || res.statusText);
    throw new Error('AI missions draft failed');
  }

  return res.json();
}